var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#6202EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.768 14.832L45.384 18.216C48.84 21.696 51 26.496 51 31.8C51 42.408 42.408 51 31.8 51C21.192 51 12.6 42.408 12.6 31.8C12.6 22.008 19.92 13.944 29.4 12.768V17.616C22.584 18.768 17.4 24.672 17.4 31.8C17.4 39.744 23.856 46.2 31.8 46.2C39.744 46.2 46.2 39.744 46.2 31.8C46.2 27.816 44.592 24.216 41.976 21.624L38.592 25.008C40.32 26.76 41.4 29.16 41.4 31.8C41.4 37.104 37.104 41.4 31.8 41.4C26.496 41.4 22.2 37.104 22.2 31.8C22.2 27.336 25.272 23.616 29.4 22.536V27.672C27.96 28.512 27 30.024 27 31.8C27 34.44 29.16 36.6 31.8 36.6C34.44 36.6 36.6 34.44 36.6 31.8C36.6 30.024 35.64 28.488 34.2 27.672V7.8H31.8C18.552 7.8 7.79999 18.552 7.79999 31.8C7.79999 45.048 18.552 55.8 31.8 55.8C45.048 55.8 55.8 45.048 55.8 31.8C55.8 25.176 53.112 19.176 48.768 14.832Z",
    fill: "#02BEB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8477 33.9082H30.0391L28.8438 40.7637H40.375L39.6367 45H22.9551L27.4023 19.4062H44.0488L43.293 23.6777H31.8145L30.7422 29.7773H40.5859L39.8477 33.9082Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.0f259db5.svg";
export { ForwardRef as ReactComponent };